import Error from './../view/Error';
export default [
  {
    path: '/error',
    element: Error,
    meta: {
      title: '页面没找到',
      isHeader: true, //是否展示顶部header
      hideMenu: true, //是否隐藏微信里面右上角菜单
    },
  },
];
